import React, { useEffect, useState } from "react";
import request_image from "../../../assets/images/received-request.svg";
import "../../../assets/scss/components/clientarea/serviceRequest/serviceRequest.scss";
import { config } from "../../../config/domain";
import Loader from "../../generic/loader";
import { useQuery } from "../../service/urlHelper";
import * as esignService from "../../service/esign/esignService";
import { ClevertapService } from "../../service/clevertapService";
import DeviceContext from "../../service/indentifyDevice";
import moment from "moment";
import { Idevice } from "../../types/device";

const device: Idevice = DeviceContext();

export const FinalPopupScreen = (props: any) => {
  const [loader, setLoader] = useState(false);
  const [base64Data, setBase64Data] = useState("");
  const source = useQuery().get("source");
  const clevertapService = new ClevertapService();

  useEffect(() => {
    const position = window.pageYOffset;
    if (position > 0) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
    return () => {};
  }, []);

  useEffect(() => {
    if (props.popupData.refId && !base64Data) {
      if (
        props.popupData.type !== "accClosure" &&
        props.popupData.type !== "ddpi"
      ) {
        if (!loader) {
          setLoader(true);
          if (props.popupData.type === "nomination") setLoader(true);
          esignService
            .downloadEsignDocumentV2(props.popupData.refId, source)
            .then((res: any) => {
              if (res) {
                setLoader(false);
                setBase64Data(res);
              } else {
                window.location.href = config.rootUrl + "clientarea/servicerequest"
                  // source === "nsdl_ajs"
                  //   ? config.rootUrl + "clientarea/servicerequest"
                  //   : config.root + "app/clientarea/service-request";
              }
            })
            .catch((err) => {});
        }
      } else {
        if (!loader) {
          setLoader(true);
          if (props.popupData.type === "nomination") setLoader(true);
          esignService
            .downloadEsignDocJMW(props.popupData.refId, source)
            .then((res: any) => {
              if (res) {
                if (props.popupData.type === "nomination") setLoader(false);
                setLoader(false);
                setBase64Data(res);
              } else {
                window.location.href = config.rootUrl + "clientarea/servicerequest";
                  // source === "nsdl_ajs"
                  //   ? config.rootUrl + "clientarea/servicerequest"
                  //   : config.root + "app/clientarea/service-request";
              }
            })
            .catch((err) => {
              window.location.href = config.rootUrl + "clientarea/servicerequest";
                // source === "nsdl_ajs"
                //   ? config.rootUrl + "clientarea/servicerequest"
                //   : config.root + "app/clientarea/service-request";
            });
        }
      }
    } 
    else if (props.popupData.type == "nomination") {
      let nomPdf = localStorage.getItem("nomPdf") || " "
      if (nomPdf !== " " && nomPdf !== undefined) {
        localStorage.removeItem("srId"); 
          localStorage.removeItem("signature")
          setBase64Data(nomPdf);
      //   esignService.getPreFilledFormNomination(srId)
      // .then((res: any) => {
      //   if (res) {
      //     if (props.popupData.type === "nomination") setLoader(false);
      //     setLoader(false);
      //     localStorage.removeItem("srId"); 
      //     localStorage.removeItem("signature")
      //     setBase64Data(res.data.fileData);
      //   }
      // })
      // .catch((err) => {
      //   window.location.href = config.rootUrl + "clientarea/servicerequest";
      //     // source === "nsdl_ajs"
      //     //   ? config.rootUrl + "clientarea/servicerequest"
      //     //   : config.root + "app/clientarea/service-request";
      // });
     }
    }
    else if (
      props.popupData.base64Data &&
      props.popupData.type == "bankModification"
    ) {
      setBase64Data(props.popupData.base64Data);
    }
  }, [props.popupData]);

  const handleClick = async () => {
    try {
      setLoader(true);
      if (base64Data) {
        if (props.popupData.btnText == "Download form for your reference") {
          esignService.base64toPDF(base64Data, "PrefilledForm");
        } 
        else if (props.popupData.btnText == "Download Pre-filled form")  {
          esignService.base64toPDF(base64Data, "PrefilledNomForm");
          localStorage.removeItem("nomPdf"); 
        }
        else esignService.base64toPDF(base64Data, "EsignedForm");
      }
      window.location.href = config.rootUrl + "clientarea/servicerequest";
        // source === "nsdl_ajs"
        //   ? config.rootUrl + "clientarea/servicerequest"
        //   : config.root + "app/clientarea/service-request";
      setLoader(false);
    } catch (error) {
      window.location.href = config.rootUrl + "clientarea/servicerequest";
        // source === "nsdl_ajs"
        //   ? config.rootUrl + "clientarea/servicerequest"
        //   : config.root + "app/clientarea/service-request";
      setLoader(false);
    }
  };

  const triggerClvrTap = () => {
    var data = {
      EventName: "Successful_SR",
      InitiationElement: "SrFinal_Popup_Close",
      InitiationScreen: window.location.pathname,
      LoginType: "Traditional",
      SrType: props.popupData.type?.replace(" ", "_"),
      currentTime: moment().format("DD/MM/YYYY HH:mm:ss"),
      Platform: window.localStorage.getItem("lgnSrc")
        ? window.localStorage.getItem("lgnSrc")
        : device.isMobile
        ? "Website_Mobile"
        : "Website_Desktop",
    };
    clevertapService.pushEvent(data);
  };

  return (
    <>
      {loader && (
        <div
          style={{
            textAlign: "center",
            paddingTop: "50px",
            paddingBottom: "50px",
          }}
        >
          <Loader size={50} color="blue"></Loader>
        </div>
      )}
      {!loader && props.popupData.popUp2 && (
        <div className="finalScreen poaDownload popup2 text-center">
          {props.popupData && props.popupData.type && (
            <div className="popup-heading">{props.popupData.type}</div>
          )}
          {props.popupData && props.popupData.iconName && (
            <div className="popup-icon">
              <i className={props.popupData.iconName}>
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
              </i>
            </div>
          )}
          {props.popupData && props.popupData.content && (
            <div className="flex-wrap">
              <div className="field-subHead desc text-center">
                {props.popupData.content}
              </div>
            </div>
          )}
          {props.popupData && props.popupData.contentBold && (
            <div className="flex-wrap">
              <div className="field-subHead desc text-center mg-t0 bold-text">
                {props.popupData.contentBold}
              </div>
            </div>
          )}
          {props.popupData &&
            props.popupData.redirectionLink &&
            props.popupData.redirectionText && (
              <div className="redirection-link">
                <div onClick={triggerClvrTap}>
                  <a href={props.popupData.redirectionLink}>
                    {props.popupData.redirectionText}
                  </a>
                </div>
              </div>
            )}
        </div>
      )}
      {!loader && !props.popupData.popUp2 && (
        <div className="finalScreen poaDownload">
          {props.popupData && props.popupData.headerText && (
            <div className="flex-wrap">
              <div>
                <img
                  src={request_image}
                  alt=""
                  className="received-request-img"
                />
              </div>
              <div className="head">
                <h2>{props.popupData.headerText}</h2>
              </div>
            </div>
          )}
          {props.popupData && props.popupData.content && (
            <div>
              <p className="field-subHead desc text-center">
                {props.popupData.content}
              </p>
            </div>
          )}
          <div className="ddpiFinalPopup">
            {props.popupData && props.popupData.btnText && (
              <div className="button">
                <button
                  type="button"
                  className="ed_button common_button"
                  onClick={() => {
                    if (
                      props.popupData.type &&
                      props.popupData.type !== "emailMob" &&
                      props.popupData.type !== "bank" &&
                      props.popupData.type !== "address" &&
                      props.popupData.type !== "accReact" &&
                      props.popupData.type !== "accReactPay" &&
                      props.popupData.type !== "nomination" &&
                      props.popupData.type !== "accClosure" &&
                      props.popupData.type !== "ddpi" &&
                      props.popupData.type !== "bankModification"
                    ) {
                      props.onClick();
                    } else {
                      handleClick();
                    }
                  }}
                >
                  <span className="edel-icon-download"></span>
                  <span>{props.popupData.btnText}</span>
                </button>
              </div>
            )}
            {props.popupData.type === "accReact" ? (
              <div>
                <p className="field-subHead desc text-center">
                  {" "}
                  In case you want to update bank details, please{" "}
                  <a
                    className="ed_button "
                    href={
                      config.root +
                      "/clientarea/service-request/bank-modification"
                    }
                  >
                    click here
                  </a>
                </p>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </>
  );
};
